import React, { useEffect } from "react";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { useRealModel } from "../realModel";
import { IRealDetail } from "../realService";


export function DataTable() {
    const {
        dataSource, pgCfg,
        loadData
    } = useRealModel();

    useEffect(() => {
        loadData()
    }, [])

    const columns: ColumnsType<IRealDetail> = [
        {
            title: '序号',
            width: 60,
            fixed: "left",
            render: (t, r, i) => i + 1
        }, {
            title: '从属门店',
            width: 140,
            dataIndex: 'shopName',
            fixed: "left",
        }, {
            title: '仓库',
            width: 140,
            dataIndex: 'warehouseName',
            fixed: "left",
        }, {
            title: '业务类型',
            width: 140,
            dataIndex: 'tradeTypeName',
        }, {
            title: '业务编码',
            width: 140,
            dataIndex: 'tradeTypeCode',
        }, {
            title: '创建时间',
            width: 160,
            dataIndex: 'createTime',
        }, {
            title: '期初库存金额',
            width: 100,
            dataIndex: 'openingAmount',
        }, {
            title: '库存变动金额',
            width: 100,
            dataIndex: 'liveNum',
        }, {
            title: '实时库存金额',
            width: 100,
            dataIndex: 'amount',
        }
    ];


    // //点击行选高亮
    // const onRow = (id: string) => {
    //     if (selectedRowKeys.length > 0 && selectedRowKeys[0] === id) {
    //         setSelectedRowKeys([]);
    //     } else {
    //         setSelectedRowKeys([id]);
    //     }
    // };

    return (
        <Table
            rowKey={record => record.id}
            // rowSelection={{
            //     type: "radio",
            //     selectedRowKeys: selectedRowKeys, //记录选中
            //     onChange: (selectedRowKeys: React.Key[], selectedRows: IRealDetail[]) => {
            //         setSelectedRowKeys(selectedRowKeys as string[]);
            //     }
            // }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                showTotal: (total: number) => `共${total}条`,
                position: ["bottomCenter"],
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            // onRow={record => ({
            //     onClick: () => onRow(record.id)
            // })}
            scroll={{ x: 'max-content' }}
        />
    )
}
